import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { _cs } from '@togglecorp/fujs';
import { IoEyeOutline, IoEyeOffOutline } from '../../node_modules/react-icons/io5/index.esm.js';
import useUiModeClassName from '../../hooks/useUiModeClassName.js';
import InputContainer from '../InputContainer/index.js';
import RawInput from '../RawInput/index.js';
import Button from '../Button/index.js';
import { genericMemo } from '../../utils/index.js';
import styles from './styles.css.js';

var _IoEyeOutline, _IoEyeOffOutline;

function PasswordInput(props) {
  const {
    actions,
    actionsContainerClassName,
    className,
    disabled,
    error,
    errorContainerClassName,
    hint,
    hintContainerClassName,
    icons,
    iconsContainerClassName,
    inputSectionClassName,
    label,
    labelContainerClassName,
    containerRef,
    inputSectionRef,
    readOnly,
    uiMode,
    inputElementRef,
    inputClassName,
    ...rawInputProps
  } = props;
  const uiModeClassName = useUiModeClassName(uiMode, styles.light, styles.dark);
  const [showPassword, setShowPassword] = React.useState(false);
  const handleButtonClick = React.useCallback(() => {
    setShowPassword(show => !show);
  }, []);
  return /*#__PURE__*/React.createElement(InputContainer, {
    containerRef: containerRef,
    inputSectionRef: inputSectionRef,
    actionsContainerClassName: actionsContainerClassName,
    className: className,
    disabled: disabled,
    error: error,
    errorContainerClassName: errorContainerClassName,
    hint: hint,
    hintContainerClassName: hintContainerClassName,
    icons: icons,
    iconsContainerClassName: iconsContainerClassName,
    inputSectionClassName: inputSectionClassName,
    label: label,
    labelContainerClassName: labelContainerClassName,
    readOnly: readOnly,
    uiMode: uiMode,
    actions: /*#__PURE__*/React.createElement(React.Fragment, null, actions, /*#__PURE__*/React.createElement(Button, {
      onClick: handleButtonClick,
      variant: "action",
      className: styles.showPasswordToggleButton,
      disabled: disabled,
      name: undefined,
      title: showPassword ? 'Hide password' : 'Show password'
    }, showPassword ? _IoEyeOutline || (_IoEyeOutline = /*#__PURE__*/React.createElement(IoEyeOutline, null)) : _IoEyeOffOutline || (_IoEyeOffOutline = /*#__PURE__*/React.createElement(IoEyeOffOutline, null)))),
    input: /*#__PURE__*/React.createElement(RawInput, _extends({}, rawInputProps, {
      className: _cs(styles.input, uiModeClassName, !!error && styles.errored, inputClassName),
      elementRef: inputElementRef,
      readOnly: readOnly,
      uiMode: uiMode,
      disabled: disabled,
      type: showPassword ? 'text' : 'password'
    }))
  });
}

var index = genericMemo(PasswordInput);

export { index as default };
//# sourceMappingURL=index.js.map
